import { render, staticRenderFns } from "./m-block-acquiring-order-create-receipt.vue?vue&type=template&id=999f04d6&scoped=true&lang=pug&"
import script from "./m-block-acquiring-order-create-receipt.vue?vue&type=script&lang=js&"
export * from "./m-block-acquiring-order-create-receipt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "999f04d6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
